"use client"

import { useEffect, useRef, useState } from "react"
import cn from "classnames"

import s from "./DevGrid.module.scss"

export const DevGrid = () => {
  const currentGridSetting = useRef(false)
  const [showGrid, setShowGrid] = useState(false)

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "g") {
        setShowGrid(!currentGridSetting.current)
        currentGridSetting.current = !currentGridSetting.current
      }
    }
    document.addEventListener("keydown", onKey)
    return () => {
      document.removeEventListener("keydown", onKey)
    }
  }, [])

  if (!showGrid) return null

  return <div className={cn(s.devGrid)} />
}
